import { RetrieveBitcoinAccountRequest } from '@square/dashboard-protos/models/squareup/bitty/service';
import { handleResponseError, ResponseName } from './utils';
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["RetrieveBitcoinAccountRequest"] = "RETRIEVE_BITCOIN_ACCOUNT_REQUEST";
  ActionType["RetrieveBitcoinAccountResponse"] = "RETRIEVE_BITCOIN_ACCOUNT_RESPONSE";
  return ActionType;
}({});

// Actions

export const retrieveBitcoinAccountRequestAction = () => ({
  type: ActionType.RetrieveBitcoinAccountRequest
});
export const retrieveBitcoinAccountResponseAction = (response, error) => ({
  type: ActionType.RetrieveBitcoinAccountResponse,
  response,
  error
});

// Handlers
export function handleRetrieveBitcoinAccountRequestAction(context, state, _action) {
  const request = RetrieveBitcoinAccountRequest.create({
    retrieveWallet: true
  });
  const work = () => {
    const responseAction = context.bittyApi.retrieveBitcoinAccount(request).then(retrieveBitcoinAccountResponseAction).catch(error => retrieveBitcoinAccountResponseAction(undefined, error));
    return responseAction;
  };
  return [{
    ...state
  }, work];
}
export function handleRetrieveBitcoinAccountResponseAction(context, state, action) {
  const {
    response,
    error
  } = action;
  const isError = handleResponseError(context, ResponseName.RetrieveBitcoinAccountResponse, response, error);
  if (isError) {
    return [{
      ...state
    }, null];
  }
  if (response) {
    return [{
      ...state,
      btcAccount: response.bitcoinAccount ?? null,
      walletDetails: response.walletDetails ?? null,
      accountEligibility: response.accountEligibility
    }, null];
  }
  return [{
    ...state
  }, null];
}